import { GedRequestStatus } from './gedTypes';

export const gedRequestStatusLabels: Record<GedRequestStatus, string> = {
  [GedRequestStatus.OK]: 'Succès',
  [GedRequestStatus.ERROR]: 'Échec',
};
